import { Routes } from '@angular/router';
import { authGuard, depositGuard } from './core/auth.guard';
import { crmGuard } from './core/crm.guard';
import { AccountsPage } from './pages/accounts';
import { CrmPage } from './pages/crm';
import { CrmLeadPage } from './pages/crm-lead';
import { CrmSignInPage } from './pages/crm-signin';
import { FaqsPage } from './pages/faqs';
import { HomePage } from './pages/home';
import { LanguagesPage } from './pages/languages';
import { LegalPage } from './pages/legal';
import { MarketsPage } from './pages/markets';
import { PortfolioPage } from './pages/portfolio';
import { ProfilePage } from './pages/profile';
import { SignInPage } from './pages/signin';
import { DetailsPage } from './pages/details';
import { SignUpPage } from './pages/signup';
import { TradePage } from './pages/trade';

export const routes: Routes = [
  { path: '', component: HomePage },
  { path: 'markets', component: MarketsPage },
  { path: 'accounts', component: AccountsPage },
  { path: 'faqs', component: FaqsPage },
  { path: 'languages', component: LanguagesPage },
  { path: 'trade/:symbol', component: TradePage },
  { path: 'signin', component: SignInPage },
  { path: 'signup', component: SignUpPage },
  { path: 'details', component: DetailsPage, canActivate: [authGuard] },
  { path: 'legal/terms', component: LegalPage, data: { page: 'terms' } },
  { path: 'legal/privacy', component: LegalPage, data: { page: 'privacy' } },
  { path: 'legal/cookies', component: LegalPage, data: { page: 'cookies' } },
  { path: 'legal/aml', component: LegalPage, data: { page: 'aml' } },
  { path: 'legal/risk', component: LegalPage, data: { page: 'risk' } },
  { path: 'portfolio', component: PortfolioPage, canActivate: [depositGuard] },
  { path: 'profile', component: ProfilePage, canActivate: [authGuard] },
  { path: 'crm/signin', component: CrmSignInPage },
  { path: 'crm', component: CrmPage, canActivate: [crmGuard] },
  { path: 'crm/leads/:id', component: CrmLeadPage, canActivate: [crmGuard] },
  { path: '**', redirectTo: '' },
];
